import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';

/** Hatte dieses Gerät schon einmal einen echten (Nicht-Gast-)Account? Siehe FunnelService.markKnownUser(). */
function isKnownUser(): boolean {
  try { return localStorage.getItem('kk_known_user') === '1'; } catch { return false; }
}

export const authGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // Check if user's email is verified
    if (!authService.isVerified()) {
      // Allow access to verify-email and confirm-verification pages even if not verified
      if (state.url.startsWith('/auth/verify-email') || state.url.startsWith('/auth/confirm-verification')) {
        return true;
      }
      // Allow pilot/course users through to case-editor (OTP auto-verifies,
      // but the authStore may not yet reflect it during the initial navigation)
      if (state.url.startsWith('/case-editor/')) {
        return true;
      }
      console.log('AuthGuard: Redirecting unverified user to verify-email');
      // Redirect unverified users to verify-email page
      return router.createUrlTree(['/auth/verify-email']);
    }

    // OAuth onboarding: block app access until the user completes required profile/terms data.
    // The app now allows access and shows a blocking modal (handled globally in AppComponent).
    return true;
  } else {
    // Neue Besucher (kein Account auf diesem Gerät bekannt), die auf der Wurzel
    // landen – typischerweise Social-/Affiliate-/QR-Links wie /?ref=CODE –,
    // gehen zum "Erst ausprobieren"-Einstieg statt zur Login-Wand (Issue #384).
    // Query-Parameter (ref, c, utm_*) bleiben erhalten.
    const path = state.url.split('?')[0];
    if ((path === '/' || path === '') && !isKnownUser()) {
      const query = state.url.includes('?') ? state.url.slice(state.url.indexOf('?')) : '';
      return router.parseUrl('/start' + query);
    }

    // Default redirect to login
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }
};
